import ParkingLocationsDataTable from "../../../components/dataTable/tables/ParkingLocationsDataTable";

function ParkingLocationsPageView() {
  return <ParkingLocationsDataTable />;
}

export default ParkingLocationsPageView;
